import React, { Component } from 'react';
import { Form, Button, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { checkCode, sendCode } from '../../redux/actions/CheckCode';

// Validation rules
import { hasCorrectLength } from '../../../../common/utils/validation';

// Format utilities
import { formatPhone } from '../../../../common/utils/format';

import Countdown from '../../../../common/inputs/Countdown';
import CheckCodeInput from '../../../../common/inputs/AuthorizationInputs';

const FormItem = Form.Item;

class CheckCode extends Component {
  state = {
    code: '',
    codeErrMsg: '',
    codeValidationStatus: '',
    isTimerActive: true,
    isButtonDisabled: true,
  };

  componentDidMount() {
    this.nameInput.focus()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.code !== this.props.code) {
      if (this.props.code.errorMsg && this.props.code.errorMsg !== '') {
        this.setState(state => ({
          codeValidationStatus: state.codeValidationStatus = 'error',
          codeErrMsg: this.props.code.errorMsg,
        }));
        // if (
        //   this.props.code.errorMsg ===
        //   'SMS-код недействителен или введен неверно'
        // ) {
        //   setTimeout(() => this.setState({ isButtonDisabled: false }), 60000);
        // }
      } else if (this.props.code.loading) {
        this.setState(state => ({
          codeValidationStatus: state.codeValidationStatus = 'validating',
        }));
      }
    }
  }

  validateCode(value) {
    if (!hasCorrectLength(4, value)) {
      this.setState(state => ({
        codeValidationStatus: state.codeValidationStatus = 'error',
        codeErrMsg: 'Код должен состоять из 4 цифр',
      }));
      return false;
    } else {
      this.setState(state => ({
        codeValidationStatus: state.codeValidationStatus = 'success',
        codeErrMsg: '',
      }));
      return true;
    }
  }

  sendCodeAgainHandler = e => {
    e.preventDefault();

    let { sendCode, phone } = this.props;
    console.log('Check Form send code again to phone: ', phone);
    if (!phone) phone = '+79629280989';
    sendCode({ phone: phone, addToUrl: phone });
    this.setState(
      {
        isTimerActive: false,
        codeErrMsg: '',
        code: '',
        codeValidationStatus: '',
      },
      () => {
        this.setState({
          isTimerActive: true,
        });
      }
    );
  };

  onCodeChange = value => {
    this.setState({
      code: value,
    });
  };

  checkHandler = e => {
    e.preventDefault();
    let { code } = this.state;
    let { phone, checkCode } = this.props;
    if (!phone) phone = '+79629280989';
    if (this.validateCode(code)) {
      console.log('Code valid, send it to server');
      checkCode({
        username: phone,
        password: code,
      });
    }
  };

  render() {
    let { codeErrMsg, codeValidationStatus, isTimerActive } = this.state;
    let { phone } = this.props;
    return (
      <div id="checkCodeForm" className="check-code">
        <div className="check-code__title">Подтверждение авторизации</div>
        <Form
          className="form form_check-code check-code__form"
          onSubmit={this.checkHandler}
        >
          <div className="form__field form__field_code">
            <div className="form__field-description">
              СМС отправлено на номер <br /> {phone && formatPhone(phone)}
            </div>
            <div className="form__field-input">
              <FormItem
                validateStatus={codeValidationStatus}
                help={codeErrMsg}
                hasFeedback
              >
                <CheckCodeInput
                  ref={(input) => { this.nameInput = input }}
                  autoComplete="off"
                  type="text"
                  name="code"
                  size="large"
                  mask="####"
                  value={this.state.code}
                  maxLength={4}
                  placeholder="Введите код подтверждения из СМС"
                  onChange={e => this.onCodeChange(e.target.value)}
                />
              </FormItem>
            </div>
          </div>
          <div className="form__field form__field_countdown">
            {/*<Countdown*/}
            {/*  active={isTimerActive}*/}
            {/*  clicked={this.sendCodeAgainHandler}*/}
            {/*  onChange={e => {*/}
            {/*    this.setState({ isTimerActive: e });*/}
            {/*  }}*/}
            {/*/>*/}
          </div>
          <Row gutter={16} type="flex" justify="space-between">
            <Col span={12}>
              <Button
                type="primary"
                size="large"
                style={{
                  width: '100%',
                  backgroundColor: '#ffffff',
                  color: '#00a8ff',
                }}
              >
                <Link to="/">Назад</Link>
              </Button>
            </Col>
            <Col span={12}>
              <Button
                htmlType="submit"
                type="primary"
                size="large"
                style={{ width: '100%' }}
                // disabled={!isTimerActive}
              >
                Подтвердить
              </Button>
            </Col>
          </Row>

          <Row
            type="flex"
            align="middle"
            className="form__field form__field_send-code"
          >
            <Col span={24} align="center">
              <Button
                disabled={isTimerActive}
                // disabled={this.state.isButtonDisabled}
                type="link"
                onClick={this.sendCodeAgainHandler}
              >
                Отправить код повторно
              </Button>
              {this.state.isButtonDisabled && (
                <span style={{ color: 'rgba(0,0,0,.25)' }}>
                  <Countdown
                    active={isTimerActive}
                    clicked={this.sendCodeAgainHandler}
                    onChange={e => {
                      this.setState({ isTimerActive: e });
                    }}
                  />
                </span>
              )}
            </Col>
          </Row>

          {/*{!isTimerActive ||*/}
          {/*  (this.state.codeErrMsg !== '' && (*/}
          {/*    <Row*/}
          {/*      type="flex"*/}
          {/*      align="middle"*/}
          {/*      className="form__field form__field_send-code"*/}
          {/*    >*/}
          {/*      <Col span={24} align="center">*/}
          {/*        <Button*/}
          {/*          disabled={this.state.isButtonDisabled}*/}
          {/*          type="link"*/}
          {/*          onClick={this.sendCodeAgainHandler}*/}
          {/*        >*/}
          {/*          Отправить код повторно*/}
          {/*        </Button>*/}
          {/*        {this.state.isButtonDisabled && (*/}
          {/*          <span style={{ color: 'rgba(0,0,0,.25)' }}>*/}
          {/*            <Countdown*/}
          {/*              active={isTimerActive}*/}
          {/*              clicked={this.sendCodeAgainHandler}*/}
          {/*              onChange={e => {*/}
          {/*                this.setState({ isTimerActive: e });*/}
          {/*              }}*/}
          {/*            />*/}
          {/*          </span>*/}
          {/*        )}*/}
          {/*      </Col>*/}
          {/*    </Row>*/}
          {/*  ))*/}
          {/*}*/}
        </Form>
      </div>
    );
  }
}

const checkPhoneCode = Form.create()(CheckCode);

export default connect(
  state => ({
    phone: state.Authorization.user.phone,
    code: state.Authorization.user.code,
  }),
  {
    sendCode,
    checkCode,
  }
)(checkPhoneCode);
